module.exports = __webpack_public_path__ + "0af5d249/img/document.e2130c6b.svg";